import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  Easing,
  TouchableHighlight, 
  Animated,
  TextInput,
  Dimensions,
  Platform,
  ActivityIndicator,
  Image,
  Alert,
} from 'react-native';
import {StyleContext} from '../styleC';
import { NavigationActions } from './react-navigation'; // Version can be specified in package.json
import firebase from './firebase';
import { getAuth } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";

import strings from '../strings';
import MavSelector from './mavSelector';
import MavAlert from './mavAlert';
import MavButton from './mavButton';
import RNFetchBlob from './RNFetchBlob';
import info from '../info';
const timer = require('react-native-timer'); 
import MavInfoBubble from './mavInfoBubble';
import TextPresentation from './textPresentation';
import MavMiniButton from './mavMiniButton';







export default class account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ads:{},
      adsFullScreen:{},      
    };
  }


  loadAds(fullSize){
    var refer=(fullSize===true)?"/settings/adsFullScreen":"/settings/ads"; 

    get(child(ref(getDatabase(firebase)), refer)).then(value => {

      var val2 = value.val();
      if(val2!=null){

          var i;
          var list=Object.keys(val2)
          for(i=0;i<list.length;i++){
                if(val2[list[i]].index==undefined) val2[list[i]].index=i;
          }
           
          var val3={}

          Object.keys(val2).sort(function(a, b){
              if(val2[a] < val2[b]) return -1;
              if(val2[a] > val2[b]) return 1;
              return 0;
          });

          var list=Object.keys(val2).sort( function ( a, b ) { return val2[a].index - val2[b].index  } )

          for(i=0;i<list.length;i++){
            val3[list[i]]=val2[list[i]];
          }
          
          if(val2!=null){
            if(fullSize===true) this.setState({adsFullScreen:val3, adsFullScreenSave:val3})
            else this.setState({ads:val3, adsSave:val3})

          }
    }

    })
  }
  componentDidMount() {

    this.loadAds();
    this.loadAds(true);
    

  }




takePicture(adsType, adsID){
    

    var options = {title: strings.selectPicture,chooseFromLibraryButtonTitle:strings.library, takePhotoButtonTitle:strings.camera,cancelButtonTitle:strings.cancel,maxWidth:1024, maxHeight:1024,includeBase64:true,  storageOptions: {skipBackup: true,path: 'images',quality:0.5, base64: true,}};



    
     
  }

  returnAfterServer= (data,ads,adsType, adsID, i) => {
                                        
                                        if(data.error==true) console.log("erreur")
                                        else {
                                          ads[adsID].file=data.url;
                                          /*si une image existait, je la supprime du serveur */
                                          if(ads[adsID].removeFileUUID!=undefined){
                                            console.log("je supprime "+ads[adsID].removeFileUUID)
                                            var asup=ads[adsID].removeFileUUID+"";
                                            var asup2=ads[adsID].removeFileDataType+"";
                                            getAuth(firebase).currentUser.getIdToken().then(token => {

                                              var bodyRemove={bundleIdentifer:info.bundleIdentifer,dataType:asup2, bundleAdress:info.firebaseProjectID,token:token,userID:getAuth(firebase).currentUser.uid,uuid:asup,}
                                              if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/remove',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyRemove)})
                                              else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/remove',{ 'Content-Type': 'application/json'},JSON.stringify(bodyRemove)).then(response => {})

                                              
                                            })

                                          }

                                          ads[adsID].removeFileUUID=data.uuid;
                                          ads[adsID].removeFileDataType=ads[adsID].dataType;
                                          /*une fois que j'ai le retour je supprime le waiting, apercu, data, dataType  */
                                          delete ads[adsID].waiting
                                          delete ads[adsID].apercu
                                          delete ads[adsID].data
                                          delete ads[adsID].dataType

                                          if(ads[adsID].modifIndex!=undefined){
                                            
                                            var j,k;
                                            var testVar=false;
                                            for(k=((ads[adsID].index>ads[adsID].oldIndex)?(ads[adsID].oldIndex+1):(ads[adsID].index));k<((ads[adsID].index>ads[adsID].oldIndex)?(ads[adsID].index+1):(ads[adsID].oldIndex));k++){                                  var list=Object.keys(adsTotal);
                                                var list=Object.keys(adsTotal);
                                                for(j=0; j<list.length;j++){
                                                  if(adsID!=list[j] && testVar==false){
                                                      if(adsTotal[list[j]].index==k) {
                                                        if(ads[adsID].index>ads[adsID].oldIndex) ads[list[j]].index=(k-1);
                                                        else ads[list[j]].index=(k+1);

                                                        const fireInfo={} 
                                                        if(adsType=="adsFullScreen") fireInfo['settings/adsFullScreen/'+list[j]]={index:ads[list[j]].index}
                                                        else fireInfo['settings/ads/'+list[j]]={index:ads[list[j]].index}
                                                        update(ref(getDatabase(firebase)), fireInfo)
                                                        testVar=true; 
                                                  }
                                                }
                                                testVar=false;
                                              }
                                            }
                                            delete ads[adsID].oldIndex;
                                            delete ads[adsID].modifIndex;

                                          }
                                          var generate=generateUUID(); 
                                          if(adsID=="new") {
                                              ads[generate]=JSON.parse(JSON.stringify(ads[adsID]))
                                              delete ads[adsID]
                                          }
                                          
                                          if(adsType=="adsFullScreen"){
                                              this.setState({adsFullScreen:ads},() =>{
                                                  const fireInfo={} 
                                                  
                                                  fireInfo['settings/adsFullScreen/'+generate]=ads[generate]
                                                  
                                                  console.log(fireInfo)
                                                  update(ref(getDatabase(firebase)), fireInfo)

                                              })
                                              this['viewAdsFS_' + i].close();
                                          }
                                          else {
                                              /*j'envoi les infos */
                                              this.setState({ads:ads},() =>{
                                                  const fireInfo={} 
                                                  if(adsID=="new") fireInfo['settings/ads/'+generate]=ads[generate]
                                                  else fireInfo['settings/ads/'+adsID]=ads[adsID]
                                                  update(ref(getDatabase(firebase)), fireInfo)

                                              })
                                              this['viewAds_' + i].close();
                                            }
                                        }
  }



  uploadAds(adsType, adsID, i){
                var adsTotal=(adsType=="adsFullScreen")?this.state.adsFullScreen:this.state.ads
                if(adsTotal[adsID].name==undefined || adsTotal[adsID].name=="") this.alert.onAlert({title:strings.thankWriteName});  
                else if(adsTotal[adsID].file==undefined && adsTotal[adsID].apercu==undefined) this.alert.onAlert({title:strings.noFileUpload});  
                else if(adsTotal[adsID].action!=undefined && adsTotal[adsID].action!="" && (adsTotal[adsID].link==undefined || adsTotal[adsID].link=="")) this.alert.onAlert({title:strings.noLink});  
                else {
                    var final=JSON.parse(JSON.stringify(adsTotal[adsID]));
                    var ads=JSON.parse(JSON.stringify(adsTotal));

                    if(adsTotal[adsID].target!=undefined && (adsTotal[adsID].target[0]!=true || adsTotal[adsID].target[1]!=true || adsTotal[adsID].target[2]!=true)) delete final.target;
                    delete ads[adsID].modif;

                    if(adsTotal[adsID].apercu!=undefined){
                      /*je vais envoyer l'image sur le serveur */
                      /*j'affiche un waiting */
                      ads[adsID].waiting=true; 
                      if(adsType=="adsFullScreen") this.setState({adsFullScreen:ads}); 
                      else this.setState({ads:ads}); 

                      getAuth(firebase).currentUser.getIdToken().then(token => {

                          var bodyInfo={
                              bundleIdentifer:info.bundleIdentifer,
                              bundleAdress:info.firebaseProjectID,
                              token:token,
                              userID:getAuth(firebase).currentUser.uid,
                              data:adsTotal[adsID].data,
                              pictureUsage:"ads",
                              dataType:adsTotal[adsID].dataType,
                          }
                          if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/upload',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyInfo)}).then((response) => response.json()).then((data) => { if(typeof(data)=="string") data=JSON.parse(data);  this.returnAfterServer(data,ads, adsType, adsID, i); })
                          else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/upload',{ 'Content-Type': 'application/json'},JSON.stringify(bodyInfo)).then(response => {if(typeof(response.data)=="string") response.data=JSON.parse(response.data);  this.returnAfterServer(response.data,ads, adsType, adsID, i); })


            

                      })
                      

                    } else {

                        if(ads[adsID].modifIndex!=undefined){
                                            
                              var j,k;
                              var testVar=false;
                                for(k=((ads[adsID].index>ads[adsID].oldIndex)?(ads[adsID].oldIndex+1):(ads[adsID].index));k<((ads[adsID].index>ads[adsID].oldIndex)?(ads[adsID].index+1):(ads[adsID].oldIndex));k++){                                  var list=Object.keys(adsTotal);
                                  for(j=0; j<list.length;j++){
                                    if(adsID!=list[j] && testVar==false){
                                        if(adsTotal[list[j]].index==k) {
                                          if(ads[adsID].index>ads[adsID].oldIndex) ads[list[j]].index=(k-1);
                                          else ads[list[j]].index=(k+1);
                                          const fireInfo={} 
                                          if(adsType=="adsFullScreen") fireInfo['settings/adsFullScreen/'+list[j]]={index:ads[list[j]].index}
                                          else fireInfo['settings/ads/'+list[j]]={index:ads[list[j]].index}
                                          update(ref(getDatabase(firebase)), fireInfo)

                                          testVar=true; 
                                    }
                                  }
                                  testVar=false;
                                }
                              }
                              delete ads[adsID].oldIndex;
                              delete ads[adsID].modifIndex;

                            }

                        if(adsType=="adsFullScreen"){
                            this.setState({adsFullScreen:ads},() =>{
                              const fireInfo={} 
                              if(adsID=="new") fireInfo['settings/adsFullScreen/'+generate]=ads[generate]
                              else fireInfo['settings/adsFullScreen/'+adsID]=ads[adsID]
                              update(ref(getDatabase(firebase)), fireInfo)


                            })
                            this['viewAdsFS_' + i].close();
                        }
                        else {
                            /*j'envoi les infos */
                            this.setState({ads:ads},() =>{
                              const fireInfo={} 
                              if(adsID=="new") fireInfo['settings/ads/'+generate]=ads[generate]
                              else fireInfo['settings/ads/'+adsID]=ads[adsID]
                              update(ref(getDatabase(firebase)), fireInfo)
                              

                            })
                            this['viewAds_' + i].close();
                          }
                    }

                }
  }

  removeAds(adsType, adsID, i){
      var adsTotal=(adsType=="adsFullScreen")?this.state.adsFullScreen:this.state.ads
      var ads=(adsType=="adsFullScreen")?this.state.adsFullScreen:this.state.ads;
      if(adsTotal.new==undefined){
        if(adsType=="adsFullScreen") this['viewAdsFS_' + i].close();
        else this['viewAds_' + i].close();

        /*je décale l'index chez les autres*/
        var testVar=false;
        var k; 
        for(k=ads[adsID].index+1;k<Object.keys(ads).length;k++){
              var list=Object.keys(adsTotal);
              for(j=0; j<list.length;j++){
                if(adsID!=list[j] && testVar==false){
                    if(adsTotal[list[j]].index==k) {
                      ads[list[j]].index=(k-1);

                      const fireInfo={} 

                      if(adsType=="adsFullScreen") fireInfo['settings/adsFullScreen/'+list[j]]={index:ads[list[j]].index}
                      else fireInfo['settings/ads/'+list[j]]={index:ads[list[j]].index}
                      update(ref(getDatabase(firebase)), fireInfo)

                      testVar=true; 
                }
              }
              testVar=false;
            }
        }
        /*je supprime l'image si besoin*/
        if(ads[adsID].removeFileUUID!=undefined){
            console.log("je supprime "+ads[adsID].removeFileUUID)
            var asup=ads[adsID].removeFileUUID+"";
            var asup2=ads[adsID].removeFileDataType+"";
            getAuth(firebase).currentUser.getIdToken().then(token => {

              var bodyRemove={bundleIdentifer:info.bundleIdentifer,dataType:asup2, bundleAdress:info.firebaseProjectID,token:token,userID:getAuth(firebase).currentUser.uid,uuid:asup,}
              if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/remove',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyRemove)})
              else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/remove',{ 'Content-Type': 'application/json'},JSON.stringify(bodyRemove)).then(response => {})


            })

        }

        /*je supprime la ref */
        
        const fireInfo={} 
        if(adsType=="adsFullScreen") fireInfo['settings/adsFullScreen/'+adsID]=null
        else fireInfo['settings/ads/'+adsID]=null
        update(ref(getDatabase(firebase)), fireInfo)
        
        delete ads[adsID]
        if(adsType=="adsFullScreen") this.setState({adsFullScreen:ads}); 
        else this.setState({ads:ads}); 


      }
      else {
        delete ads.new
        if(adsType=="adsFullScreen") this.setState({adsFullScreen:ads}); 
        else this.setState({ads:ads}); 
      }

  }





    viewAction = (adsType,adsID) => {
      var ads=(adsType=="bottom")?this.state.ads:this.state.adsFullScreen;

      var list=[
          {text:strings.doNothing, action:"", selected:(ads[adsID].action=="" || ads[adsID].action==undefined)?true:false },
          {text: strings.goWeb, action:"web", selected:(ads[adsID].action=="web")?true:false},
          {text: strings.goContact, action:"contact",  selected:(ads[adsID].action=="contact")?true:false},
          {text: strings.goCopyClipboard, action:"clipboard", selected:(ads[adsID].action=="clipboard")?true:false},
      ];

      this.alert.onAlert({title:strings.actionOnClick, subTitle:strings.actionOnClickMoreInfo, items:list, buttons:[{text: strings.validate,onPress: (idList) => {

          var ads=JSON.parse(JSON.stringify((adsType=="bottom")?this.state.ads:this.state.adsFullScreen)); 
          ads[adsID].action=list[idList].action; 
          ads[adsID].modif=true;    
          if(adsType=="bottom")this.setState({ads:ads})
          else this.setState({adsFullScreen:ads})

      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

  }



  viewTarget = (adsType, adsID) => {
          var ads=(adsType=="bottom")?this.state.ads:this.state.adsFullScreen;

      var list=[
        {text:strings.customer, selected:(ads[adsID].target==undefined || ads[adsID].target[0]==true)?true:false },
        {text:strings.partner, selected:(ads[adsID].target==undefined || ads[adsID].target[1]==true)?true:false },
        {text:strings.providerAffair, selected:(ads[adsID].target==undefined || ads[adsID].target[2]==true)?true:false },


      ];
  
      this.alert.onAlert({title:strings.target, subTitle:strings.selectUsersAds, items:list,multiSelected:true, buttons:[{text: strings.validate,onPress: (list) => {
        var ads=JSON.parse(JSON.stringify((adsType=="bottom")?this.state.ads:this.state.adsFullScreen)); 
        ads[adsID].target=[list[0].selected, list[1].selected, list[2].selected]
        ads[adsID].modif=true;    
        if(adsType=="bottom")this.setState({ads:ads})
        else this.setState({adsFullScreen:ads})
        


      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

     
  }


  webChoosePicture = async (adsType,adsID ,event) => {
  
  var imgType=event.target.files[0].name.split(".");
  imgType=imgType[imgType.length-1]; 

  const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0])
    fileReader.onload = () => {
        var ads=JSON.parse(JSON.stringify( ((adsType=="adsFullScreen")?this.state.adsFullScreen:this.state.ads) )); 
        ads[adsID].data=fileReader.result.replace("data:image/jpeg;base64,","").replace("data:image/png;base64,","").replace("data:image/tiff;base64,","").replace("data:image/apng;base64,","").replace("data:image/gif;base64,","")
        ads[adsID].apercu=fileReader.result
        ads[adsID].dataType=imgType
        ads[adsID].modif=true;

        if(adsType=="adsFullScreen") this.setState({adsFullScreen:ads}); 
        else  this.setState({ads:ads}) 



    }
    fileReader.onerror = (error) => {
      this.alert.onAlert({title:strings.errorDefault})
    }

  




        

};


  

  render() {

    return (
      <StyleContext.Consumer>{style => 
      <ScrollView style={{flex:1,backgroundColor:style.backgroundColor}}>
      <View style={{flex:1,marginLeft: 0, marginRight: 0, backgroundColor: style.backgroundColor}}>



         <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/adsBottom_white.png'):require('../assets/adsBottom_black.png')} title={strings.adsBottom} subTitle={strings.adsBottomMoreInfo}  style={{marginTop:10,marginBottom:20}} />
         <MavInfoBubble type={"help"} videoLink={"https://www.youtube.com/watch?v=ulsqiDvZW58"} tutdoLink={"http://www.google.fr"} style={{marginTop:0,marginBottom:20}} />

          {Object.keys(this.state.ads).map((adsID,i) => ( <TextPresentation disable={(this.state.ads.new!=undefined)?true:undefined} onOpen={()=>{ 
            if(this.state.ads.new==undefined){ 
              for(var k=0; k<Object.keys(this.state.ads).length;k++){if(k!=parseInt(i)) this['viewAds_' + k].close();}
            } 
            }} 
            ref={viewAds => {this['viewAds_' + i] = viewAds;}} textMini={(this.state.ads[adsID].modif==true && adsID!="new")?"(Modifications non enregistrées)":undefined} text={(this.state.ads[adsID].name!=undefined &&this.state.ads[adsID].name!="")?this.state.ads[adsID].name:strings.adsNoName} icon={(style.mode=="dark")?require('../assets/megaphone_white.png'):require('../assets/megaphone_black.png')} >

            {Platform.OS!="web" && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.takePicture("ads",adsID)}}>
                <View style={{marginTop:15,marginLeft:"5%", marginRight:"5%", height:50, backgroundColor:style.backgroundColor,borderRadius: 5,borderWidth: 1, borderColor:style.backgroundColor,shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 0,width: 0},elevation:1 }}>

                    {(this.state.ads[adsID].apercu==undefined && this.state.ads[adsID].file!=undefined) && <Image source={{uri:this.state.ads[adsID].file}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {this.state.ads[adsID].apercu!=undefined && <Image source={{uri:this.state.ads[adsID].apercu}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {(this.state.ads[adsID].apercu==undefined) && <View style={{position:"absolute", width:"100%", height:"100%",justifyContent:"center", alignItems:"center",}}> 
                    <Text style={{ textAlign:"center", color: (this.state.ads[adsID].file!=undefined)?style.backgroundColorContrast:style.textInputColor,fontSize: style.textInputFontSize*1.2}}>{(this.state.ads[adsID].file!=undefined)?strings.clickToModify:strings.defineImageAds}</Text>
                    </View>}

                </View>
            </TouchableHighlight>}
                
            {Platform.OS=="web" && <label>
               <input type="file" accept="image/*" style={{display:'none'}} name="photo" onChange={(event) => {this.webChoosePicture("ads",adsID, event)}}  />

                <View style={{marginTop:15,marginLeft:"5%", marginRight:"5%", height:50, backgroundColor:style.backgroundColor,borderRadius: 5,borderWidth: 1, borderColor:style.backgroundColor,shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 0,width: 0},elevation:1 }}>
                    {(this.state.ads[adsID].apercu==undefined && this.state.ads[adsID].file!=undefined) && <Image source={{uri:this.state.ads[adsID].file}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {this.state.ads[adsID].apercu!=undefined && <Image source={{uri:this.state.ads[adsID].apercu}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {(this.state.ads[adsID].apercu==undefined) && <View style={{position:"absolute", width:"100%", height:"100%",justifyContent:"center", alignItems:"center",}}> 
                    <Text style={{ textAlign:"center", color: (this.state.ads[adsID].file!=undefined)?style.backgroundColorContrast:style.textInputColor,fontSize: style.textInputFontSize*1.2}}>{(this.state.ads[adsID].file!=undefined)?strings.clickToModify:strings.defineImageAds}</Text>
                    </View>}

                </View>
            </label>}


            <TextPresentation text={(this.state.ads[adsID].name!=undefined)?this.state.ads[adsID].name:""} textExplication={strings.adsName} placeholder={"ex : Hotel du lac"} onChangeText={(text)=>{var ads=JSON.parse(JSON.stringify(this.state.ads)); ads[adsID].name=text; ads[adsID].modif=true;    this.setState({ads:ads})}}/>
            

            <TextPresentation reduceTextSizeOnOff={true} editable={false} selectedQuantity={this.state.ads[adsID].duration+"s"} text={strings.duration} onChangeQuantity={(value)=>{
                    var ads=JSON.parse(JSON.stringify(this.state.ads));
                    ads[adsID].duration+=value;
                    if(ads[adsID].duration<1) ads[adsID].duration=1;
                    ads[adsID].modif=true;    
                    this.setState({ads:ads}) }} 
            />

            <TextPresentation textRight={strings.modify} forceClick={()=>{ this.viewAction("bottom",adsID) }} onTextRightClick={()=>{ this.viewAction("bottom",adsID) }}  text={(this.state.ads[adsID].action=="" || this.state.ads[adsID].action==undefined)?strings.doNothing:( (this.state.ads[adsID].action=="web")?strings.goWeb:((this.state.ads[adsID].action=="contact")?strings.goContact:strings.goCopyClipboard ) ) }  textExplication={strings.actionOnClick} textExplicationSmall={strings.actionOnClickMoreInfo} editable={false} />
           
            {(this.state.ads[adsID].action!="" && this.state.ads[adsID].action!=undefined) && <TextPresentation text={(this.state.ads[adsID].link!=undefined)?this.state.ads[adsID].link:""} multiline={(this.state.ads[adsID].action=="web")?false:true} textExplication={(this.state.ads[adsID].action=="web")?strings.link:( (this.state.ads[adsID].action=="contact")? strings.preFillContact:strings.textCopyClipboard     )} placeholder={(this.state.ads[adsID].action=="web")?"https://www.hotel-du-lac.com":( (this.state.ads[adsID].action=="contact")? "Bonjour, j'aimerais plus d'info":"HAPPY10" )} onChangeText={(text)=>{var ads=JSON.parse(JSON.stringify(this.state.ads)); ads[adsID].link=text; ads[adsID].modif=true;    this.setState({ads:ads})}}/>}

            <TextPresentation textRight={strings.modify} forceClick={()=>{ this.viewTarget("bottom",adsID) }} onTextRightClick={()=>{ this.viewTarget("bottom",adsID) }}  text={((this.state.ads[adsID].target==undefined || (this.state.ads[adsID].target[0]==true && this.state.ads[adsID].target[1]==true && this.state.ads[adsID].target[2]==true))?(strings.all+"\n"):( ((this.state.ads[adsID].target[0]==true)?(strings.customer+"\n"):"")+((this.state.ads[adsID].target[1]==true)?(strings.partner+"\n"):"")+((this.state.ads[adsID].target[2]==true)?(strings.providerAffair+"\n"):"")  ))}  textExplication={strings.target} textExplicationSmall={strings.selectUsersAds} editable={false} />

            {this.state.ads[adsID].waiting!=true && <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                  {(this.state.adsSave!=undefined && this.state.adsSave[adsID]!=undefined) && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewAds_' + i].close(); var opt=this.state.ads; opt[adsID]=this.state.adsSave[adsID]; this.setState({ads:opt})     }} />}
                  <MavMiniButton style={{marginLeft:(this.state.adsSave!=undefined && this.state.adsSave[adsID]!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{  this.uploadAds("ads", adsID, i)   }} />
                  <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removeAds("ads", adsID, i);  }} />
            </View>}

            {this.state.ads[adsID].waiting==true && <ActivityIndicator style={{marginTop:40}} size="large" color={style.color1} />}

          </TextPresentation>))}

          


          {(this.state.ads.new==undefined) && <View style={{alignItems:"center",justifyContent:"center", marginTop:30}}>
                <MavButton text={strings.add} onlyButton={true} onPress={()=>{ var ads=JSON.parse(JSON.stringify(this.state.ads)); ads.new={duration:5, index:Object.keys(this.state.ads).length}; this.setState({ads:ads},() =>{ 
                      var k;
                      for(var k=0; k<Object.keys(this.state.ads).length;k++){this['viewAds_' + k].close();}
                      this['viewAds_' + (Object.keys(this.state.ads).length-1)].open();
                 })    }}/>
          </View>}


          <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/adsCenter_white.png'):require('../assets/adsCenter_black.png')} title={strings.adsFullScreen} subTitle={strings.adsFullScreenMoreInfo}  style={{marginTop:20,marginBottom:20}} />






             {Object.keys(this.state.adsFullScreen).map((adsID,i) => ( <TextPresentation disable={(this.state.adsFullScreen.new!=undefined)?true:undefined} onOpen={()=>{ 
                if(this.state.adsFullScreen.new==undefined){ 
                  for(var k=0; k<Object.keys(this.state.adsFullScreen).length;k++){if(k!=parseInt(i)) this['viewAdsFS_' + k].close();}
                } 
              }} 
              ref={viewAdsFS => {this['viewAdsFS_' + i] = viewAdsFS;}} textMini={(this.state.adsFullScreen[adsID].modif==true && adsID!="new")?"(Modifications non enregistrées)":undefined} text={(this.state.adsFullScreen[adsID].name!=undefined &&this.state.adsFullScreen[adsID].name!="")?this.state.adsFullScreen[adsID].name:strings.adsNoName} icon={(style.mode=="dark")?require('../assets/megaphone_white.png'):require('../assets/megaphone_black.png')} >

              {Platform.OS!="web" && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.takePicture("adsFullScreen", adsID)}}>
                <View style={{marginTop:15,marginLeft:"5%", marginRight:"5%", height:250, backgroundColor:style.backgroundColor,borderRadius: 5,borderWidth: 1, borderColor:style.backgroundColor,shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 0,width: 0},elevation:1 }}>

                    {(this.state.adsFullScreen[adsID].apercu==undefined && this.state.adsFullScreen[adsID].file!=undefined) && <Image source={{uri:this.state.adsFullScreen[adsID].file}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {this.state.adsFullScreen[adsID].apercu!=undefined && <Image source={{uri:this.state.adsFullScreen[adsID].apercu}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {(this.state.adsFullScreen[adsID].apercu==undefined) && <View style={{position:"absolute", width:"100%", height:"100%",justifyContent:"center", alignItems:"center",}}> 
                    <Text style={{ textAlign:"center", color: (this.state.adsFullScreen[adsID].file!=undefined)?style.backgroundColorContrast:style.textInputColor,fontSize: style.textInputFontSize*1.2}}>{(this.state.adsFullScreen[adsID].file!=undefined)?strings.clickToModify:strings.defineImageAds}</Text>
                    </View>}

                </View>
              </TouchableHighlight>}


               {Platform.OS=="web" && <label>
               <input type="file" accept="image/*" style={{display:'none'}} name="photo" onChange={(event) => {this.webChoosePicture("adsFullScreen",adsID, event)}}  />
                <View style={{marginTop:15,marginLeft:"5%", marginRight:"5%", height:250, backgroundColor:style.backgroundColor,borderRadius: 5,borderWidth: 1, borderColor:style.backgroundColor,shadowOpacity: 0.3,shadowRadius:2,shadowOffset: {height: 0,width: 0},elevation:1 }}>

                    {(this.state.adsFullScreen[adsID].apercu==undefined && this.state.adsFullScreen[adsID].file!=undefined) && <Image source={{uri:this.state.adsFullScreen[adsID].file}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {this.state.adsFullScreen[adsID].apercu!=undefined && <Image source={{uri:this.state.adsFullScreen[adsID].apercu}} style={{borderRadius: 5,borderWidth: 1,borderColor:style.backgroundColor, height:"100%", width:"100%",resizeMode:"contain"}}/>}
                    {(this.state.adsFullScreen[adsID].apercu==undefined) && <View style={{position:"absolute", width:"100%", height:"100%",justifyContent:"center", alignItems:"center",}}> 
                    <Text style={{ textAlign:"center", color: (this.state.adsFullScreen[adsID].file!=undefined)?style.backgroundColorContrast:style.textInputColor,fontSize: style.textInputFontSize*1.2}}>{(this.state.adsFullScreen[adsID].file!=undefined)?strings.clickToModify:strings.defineImageAds}</Text>
                    </View>}

                </View>

              </label>}

            <TextPresentation text={(this.state.adsFullScreen[adsID].name!=undefined)?this.state.adsFullScreen[adsID].name:""} textExplication={strings.adsName} placeholder={"ex : Hotel du lac"} onChangeText={(text)=>{var ads=JSON.parse(JSON.stringify(this.state.adsFullScreen)); ads[adsID].name=text; ads[adsID].modif=true;    this.setState({adsFullScreen:ads})}}/>
            

            <TextPresentation textRight={strings.modify} forceClick={()=>{ this.viewAction("center",adsID) }} onTextRightClick={()=>{ this.viewAction("center",adsID) }}  text={(this.state.adsFullScreen[adsID].action=="" || this.state.adsFullScreen[adsID].action==undefined)?strings.doNothing:( (this.state.adsFullScreen[adsID].action=="web")?strings.goWeb:((this.state.adsFullScreen[adsID].action=="contact")?strings.goContact:strings.goCopyClipboard ) ) }  textExplication={strings.actionOnClick} textExplicationSmall={strings.actionOnClickMoreInfo} editable={false} />
           
            {(this.state.adsFullScreen[adsID].action!="" && this.state.adsFullScreen[adsID].action!=undefined) && <TextPresentation text={(this.state.adsFullScreen[adsID].name!=undefined)?this.state.adsFullScreen[adsID].name:""} multiline={(this.state.adsFullScreen[adsID].action=="web")?false:true} textExplication={(this.state.adsFullScreen[adsID].action=="web")?strings.link:( (this.state.adsFullScreen[adsID].action=="contact")? strings.preFillContact:strings.textCopyClipboard     )} placeholder={(this.state.adsFullScreen[adsID].action=="web")?"https://www.hotel-du-lac.com":( (this.state.adsFullScreen[adsID].action=="contact")? "Bonjour, j'aimerais plus d'info":"HAPPY10" )} onChangeText={(text)=>{var ads=JSON.parse(JSON.stringify(this.state.adsFullScreen)); ads[adsID].link=text; ads[adsID].modif=true;    this.setState({adsFullScreen:ads})}}/>}

            
            <TextPresentation textRight={strings.modify} forceClick={()=>{ this.viewTarget("center",adsID) }} onTextRightClick={()=>{ this.viewTarget("center",adsID) }}  text={((this.state.adsFullScreen[adsID].target==undefined || (this.state.adsFullScreen[adsID].target[0]==true && this.state.adsFullScreen[adsID].target[1]==true && this.state.adsFullScreen[adsID].target[2]==true))?(strings.all+"\n"):( ((this.state.adsFullScreen[adsID].target[0]==true)?(strings.customer+"\n"):"")+((this.state.adsFullScreen[adsID].target[1]==true)?(strings.partner+"\n"):"")+((this.state.adsFullScreen[adsID].target[2]==true)?(strings.providerAffair+"\n"):"")  ))}  textExplication={strings.target} textExplicationSmall={strings.selectUsersAds} editable={false} />


            {this.state.adsFullScreen[adsID].waiting!=true && <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                  {(this.state.adsFullScreenSave!=undefined && this.state.adsFullScreenSave[adsID]!=undefined) && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewAdsFS_' + i].close(); var opt=this.state.adsFullScreen; opt[adsID]=this.state.adsFullScreenSave[adsID]; this.setState({adsFullScreen:opt})     }} />}
                  <MavMiniButton style={{marginLeft:(this.state.adsFullScreenSave!=undefined && this.state.adsFullScreenSave[adsID]!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{  this.uploadAds("adsFullScreen", adsID, i)   }} />
                  <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removeAds("adsFullScreen", adsID, i);  }} />
            </View>}
      
            {this.state.adsFullScreen[adsID].waiting==true && <ActivityIndicator style={{marginTop:40}} size="large" color={style.color1} />}



          </TextPresentation>))}


























              {(this.state.adsFullScreen.new==undefined) && <View style={{alignItems:"center",justifyContent:"center", marginTop:30}}>
                <MavButton text={strings.add} onlyButton={true} onPress={()=>{ 

                  var ads=JSON.parse(JSON.stringify(this.state.adsFullScreen)); ads.new={index:Object.keys(this.state.adsFullScreen).length}; this.setState({adsFullScreen:ads},() =>{ 
                      var k;
                      for(var k=0; k<Object.keys(this.state.adsFullScreen).length;k++){this['viewAdsFS_' + k].close();}
                      this['viewAdsFS_' + (Object.keys(this.state.adsFullScreen).length-1)].open();
                 })   



                 }}/>
            </View>}


            <View style={{width:50, height:50}}/>


          


       

      </View>

       

      <MavAlert ref={alert => {this.alert = alert;}}/>
  </ScrollView>
  }</StyleContext.Consumer>
    );
  }
}




export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
